import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOrderMethod, useOrderAvailableMethods } from '@/hooks/api/order';

const OrderExpectedAtLabel = () => {
    const [t] = useTranslation('order.datetime');
    const method = useOrderMethod();
    const available_methods = useOrderAvailableMethods();

    return (
        <div data-view="order-expected-at-label">
            {method &&
                method !== 'delivery' &&
                available_methods?.length === 1 && (
                    <div className="m2g-order-section-header">
                        <span className="m2g-order-section-title">
                            {t(`${method}_time_label`)}
                        </span>
                    </div>
                )}
        </div>
    );
};

export default OrderExpectedAtLabel;
